import React from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { t } from 'ttag'
import { updateSelectedFilters } from 'store/actions/filters'
import Button from 'components/ui/Button'
import FilterTitle from 'components/ui/FilterTitle'
import SearchFilter from 'components/ui/SearchFilter'
import SelectedFilter from 'components/ui/SelectedFilter'
import FilterText from 'components/ui/FilterText'
import RemoveIcon from 'components/ui/RemoveIcon'
import CustomCheckbox from 'components/ui/CustomCheckbox'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import { SELECTED_FILTER_MAX_LINES } from 'store/constants/constants'
import Dotdotdot from 'react-dotdotdot'

const FilterSection = styled.div`
  margin-bottom: 15px;
`

const Input = styled.input`
  margin-right: 5px;
`

const Label = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: #4a4a4a;
`

function Investments({ type, title, onClose, showFilter, customTop }) {
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters
  let checkboxSelected =
    filters.selectedFilters[currentSearchable][type].only_infrastructure_financed
  if (!checkboxSelected) checkboxSelected = false

  return (
    <PureInvestments
      type={type}
      title={title}
      onClose={onClose}
      showFilter={showFilter}
      customTop={customTop}
      checkboxSelected={checkboxSelected}
    />
  )
}

const PureInvestments = React.memo(function PureInvestments({
  type,
  title,
  onClose,
  showFilter,
  customTop,
  checkboxSelected
}) {
  const dispatch = useDispatch()

  function handleCheckboxChange() {
    const checked = !checkboxSelected
    const data = {
      filterType: type,
      filterId: 'only_infrastructure_financed',
      filterValue: checked
    }
    dispatch(updateSelectedFilters(data))
  }

  function handleFilterRemove(filterId) {
    const resultingValue = null
    const data = {
      filterType: type,
      filterId,
      filterValue: resultingValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function renderSelectedValues() {
    if (checkboxSelected) {
      const filterValue = checkboxSelected
      if (filterValue != null) {
        const selectedFilterText = t`Show only projects with investments in infrastructure`
        return (
          <SelectedFilterContainer className="selected-filters">
            <SelectedFilter>
              <FilterText title={selectedFilterText}>
                <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>{selectedFilterText}</Dotdotdot>
              </FilterText>
              <RemoveIcon
                className="far fa-times"
                onClick={() => handleFilterRemove('only_infrastructure_financed')}
              />
            </SelectedFilter>
          </SelectedFilterContainer>
        )
      }
      return false
    }
    return false
  }

  return (
    <>
      <SearchFilter open={showFilter} customTop={customTop}>
        <FilterTitle>{title}</FilterTitle>
        <FilterSection>
          <CustomCheckbox>
            <Input
              type="checkbox"
              id="only_infrastructure_financed"
              name="filter-checkbox"
              value={checkboxSelected}
              checked={checkboxSelected ? 'checked' : ''}
              onChange={handleCheckboxChange}
            />
            <Label htmlFor="only_infrastructure_financed">
              {t`Show only projects with investments in infrastructure`}
            </Label>
          </CustomCheckbox>
        </FilterSection>
        <Button size="medium" onClick={onClose}>
          {t`Close`}
        </Button>
      </SearchFilter>
      <div>{renderSelectedValues()}</div>
    </>
  )
})

Investments.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string
}

PureInvestments.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string,
  checkboxSelected: PropTypes.bool
}

export default Investments
